import { memo, useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@const';
import DocumentOutlined from '@icons/DocumentOutlined';
import { openPanel, setActivePage, togglePanelCampaignCreator } from '../../../slice';
import { RootState } from '../../../store';
import NavbarButton from '../../Navbar/NavbarButton';

const CampaignButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isCampaignCreatorOpen, activePage } = useSelector(
    (state: RootState) => ({
      isCampaignCreatorOpen: state.slice.isPanelCampaignCreatorOpen,
      activePage: state.slice.activePage
    }),
    shallowEqual
  );

  const onOpenCampaignsModal = useCallback(() => {
    if (activePage !== ROUTES.HOME) {
      dispatch(setActivePage(ROUTES.HOME));
      navigate(ROUTES.HOME);
    }
    dispatch(openPanel());
    if (!isCampaignCreatorOpen) {
      dispatch(togglePanelCampaignCreator());
    }
  }, [dispatch, navigate, isCampaignCreatorOpen, activePage]);

  return (
    <NavbarButton
      viewConfig={{
        displayName: 'Campaigns',
        inactiveIcon: DocumentOutlined,
        activeIcon: DocumentOutlined,
        group: 'main',
        enabled: true
      }}
      onClick={onOpenCampaignsModal}
    />
  );
};

export default memo(CampaignButton);
